"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenSVG = exports.CloseSVG = void 0;
var _react = _interopRequireDefault(require("react"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const openIconBg = _intents.default.ux.boxLowContrast.borderColor; // bg-gray-200
const openIconFg = _intents.default.ux.box.foregroundColor; // bg-black-100
const closeIconBg = _intents.default.ux.box.foregroundColor; // bg-black-100
const closeIconFg = _intents.default.ux.box.backgroundColor; // bg-white-100

const OpenSVG = exports.OpenSVG = /*#__PURE__*/_react.default.createElement("svg", {
  className: 'open-icon',
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMinYMin"
}, /*#__PURE__*/_react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "11",
  stroke: openIconBg,
  strokeWidth: "2"
}), /*#__PURE__*/_react.default.createElement("rect", {
  x: "7",
  y: "13",
  width: "2",
  height: "10",
  transform: "rotate(-90 7 13)",
  fill: openIconFg
}), /*#__PURE__*/_react.default.createElement("rect", {
  x: "11.1919",
  y: "7",
  width: "2",
  height: "10",
  fill: openIconFg
}));
const CloseSVG = exports.CloseSVG = /*#__PURE__*/_react.default.createElement("svg", {
  className: 'close-icon',
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMinYMin"
}, /*#__PURE__*/_react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "11",
  fill: closeIconBg,
  stroke: closeIconBg,
  strokeWidth: "2"
}), /*#__PURE__*/_react.default.createElement("rect", {
  x: "7",
  y: "13",
  width: "2",
  height: "10",
  transform: "rotate(-90 7 13)",
  fill: closeIconFg
}));